import { render, staticRenderFns } from "./IndexWithDrag.vue?vue&type=template&id=4b26a803&scoped=true&"
import script from "./IndexWithDrag.vue?vue&type=script&lang=js&"
export * from "./IndexWithDrag.vue?vue&type=script&lang=js&"
import style0 from "./IndexWithDrag.vue?vue&type=style&index=0&id=4b26a803&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b26a803",
  null
  
)

export default component.exports